import { Self } from "./Self";
import { Free } from "./Free";

export function DosageInformation({ medicine }) {
  if (medicine.fillStyle === "self") return <Self {...medicine} />;
  if (medicine.fillStyle === "free") return <Free {...medicine} />;

  return  <Free {...medicine} />
}
